import { render, staticRenderFns } from "./tabEdit.vue?vue&type=template&id=56e2482d&scoped=true&"
import script from "./tabEdit.vue?vue&type=script&lang=js&"
export * from "./tabEdit.vue?vue&type=script&lang=js&"
import style0 from "./tabEdit.vue?vue&type=style&index=0&id=56e2482d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e2482d",
  null
  
)

export default component.exports